import { Spinner } from '@fluentui/react-components';
import { ReactNode, useEffect, useRef, useState } from 'react';

type TProps<T> = {
  data: T | undefined | null;
  error?: any;
  loadingMessage?: string;
  errorMessage?: string;
  plain?: boolean;
  children?: ReactNode;
  render?: (data: T) => ReactNode;
};

const StatusLabel = <T,>({
  data,
  error = null,
  loadingMessage = 'Loading ...',
  errorMessage = 'Loading failed!',
  plain = false,
  render = undefined,
  children = null,
}: TProps<T>) => {
  const [isLongLoading, setIsLongLoading] = useState(false);
  const isLoading = data === false || data === null || data === undefined;
  const refIsLoading = useRef(isLoading);
  refIsLoading.current = isLoading;

  useEffect(() => {
    if (!isLoading) setIsLongLoading(false);
    else
      setTimeout(() => {
        if (refIsLoading.current) setIsLongLoading(true);
      }, 1000);
  }, [isLoading]);

  if (!data && error) {
    if (error?.response?.data?.type === 'api' && error.response.data.message)
      errorMessage = error.response.data.message;
    if (plain) return <span>{errorMessage}</span>;
    return <p className="flex justify-center p-4 text-lg">{errorMessage}</p>;
  }

  if (isLoading) {
    if (!isLongLoading) return null;
    if (plain) return <span>{loadingMessage}</span>;
    return (
      <div className="p-4">
        <Spinner appearance="primary" label={loadingMessage} />
      </div>
    );
  }

  if (render) return <>{render(data)}</>;

  return children;
};

export { StatusLabel };
